module.exports = __webpack_public_path__ + "img/dianliang.33e363d9.png";